export default "__VITE_ASSET__CBCa0AnS__"